export default "__VITE_ASSET__lE1FLiCM__"